<template>
  <div class="page" id="certificate">
    <router-link to="/">
      <img src="@/assets/backTo.jpg" class="back" />
    </router-link>
    <img src="@/assets/honor-logo.png" alt class="logo" />

    <div class="certificate">
      <div class="awarder">
        <p>{{schoolname}}</p>
        <p>{{gradename}} {{name}}</p>
      </div>

      <div class="text">
        <p>
          你在本次活动中表现优异，荣获
          <img src="@/assets/words.png" alt class="title" />
          称号
        </p>
      </div>
      <div class="time">时间：{{certificateTime}}</div>
      <div class="seal">
        <img src="@/assets/seal.png" alt />
        <p class="sealcode">{{certificateNumber}}</p>
      </div>
    </div>

    <div class="canvas">
      <img src="@/assets/flagpole.png" alt class="flagpole" />
      <canvas id="canvas"></canvas>
    </div>
    <div class="cert-canvas">
      <canvas id="cert-canvas"></canvas>
    </div>

    <img src="@/assets/honor-people.png" alt class="people" />
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
